// extracted by mini-css-extract-plugin
module.exports = {"spinner":"loading-spinner_spinner__1rZkR","spin":"loading-spinner_spin__1B9XT"};